import { FC, forwardRef, useState } from 'react'
import { Box, Typography, styled } from '@mui/material'
import { Icon } from '../../eid-icons'
import { Modal } from './Modal'
import IconButton from '../IconButton'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

const Button = styled('button')(({ theme }) => ({
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    textAlign: 'left',
    width: '100%',
    font: 'inherit',
    color: 'inherit',
}))

const ModalHeader = styled(Box)(({ theme }) => ({
    padding: '2rem',
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    backgroundColor: '#0057A0',
    backgroundImage: 'linear-gradient(105deg, #682a94, #05afe0)',
}))

const Content = styled(Box)(({ theme }) => ({
    color: '#000000',
    marginTop: '6.4rem',
}))

const Title = styled(Typography)(({ theme }) => ({
    fontSize: '1.6rem',
    fontWeight: 'bold',
    color: '#ffffff',
}))

const CloseIcon = styled(Box)(({ theme }) => ({
    position: 'absolute',
    right: '2rem',
    top: '1.6rem',
    height: '1rem',
    cursor: 'pointer',
}))

const getIframeStyles = (height?: string) => ({
    border: 'none',
    width: '100%',
    height: height ? height : '78vh',
    margin: 0,
    padding: 0,
})

export type EidIFrameProps = {
    url: string
    title: string
    className?: string
    height?: string
    children?: React.ReactNode
}

export const EidIFrame: FC<EidIFrameProps> = forwardRef((props, ref) => {
    const [showModal, setShowModal] = useState(false)
    const { t } = useTranslation()

    const header = (
        <ModalHeader>
            <Title id="eid-iframe-dialog-title">{props.title}</Title>
            <CloseIcon>
                <IconButton
                    aria-label={t('Common_Close')}
                    onClick={() => setShowModal(false)}
                    size="large"
                    sx={{ color: '#ffffff' }}
                >
                    <Icon name="Close" color="#ffffff" />
                </IconButton>
            </CloseIcon>
        </ModalHeader>
    )

    return (
        // @ts-ignore
        <div ref={ref}>
            <Modal
                open={showModal}
                onClose={() => setShowModal(false)}
                title={props.title}
                header={header}
            >
                <Content>
                    {showModal && (
                        <iframe
                            title={props.title}
                            style={getIframeStyles(props.height)}
                            src={props.url}
                        />
                    )}
                </Content>
            </Modal>
            <Button
                onClick={() => setShowModal(true)}
                className={classNames(props.className)}
            >
                {props.children}
            </Button>
        </div>
    )
})
